import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { IntegrationHistoryEvent } from "@modules/erpIntegrations/types";

import { ListIntegrationHistoryFilters } from "./types";

export async function getIntegrationHistoryService(
  filters: ListIntegrationHistoryFilters
): Promise<ApiResponse<IntegrationHistoryEvent>> {
  const { data } = await api.get<ApiResponse<IntegrationHistoryEvent>>(
    "/v1/integration_history_admin/",
    {
      params: {
        resource: "integration_endpoint",
        object_id: filters.objectId,
        page: filters.page ?? 1,
        page_size: filters.perPage ?? 10,
        ordering: "-created_at,-id",
        ...(filters.action ? { action: filters.action } : {}),
      },
    }
  );

  return data;
}
